import React from "react";
import { NormalButton } from "../NormalButton";
import drive from "assets/svg/driveImg.svg";
import driveBanner from "assets/images/DriveBanner.png";
import "./style.scss";
import { Link } from "react-router-dom";

export const RewardCard = ({ cardSubTitle, subtitleClass, label, className }) => {
    const trackEvent = (tabClicked) => {
        window.lmSMTObj.track(tabClicked);
      }
    return (
        <div className="rewardConatiner">
            <img src={driveBanner} className="img-fluid driveBanner" alt="banner" />
            <div className="rewardSubContainer">
                <img src={drive} className="img-fluid appdevice" alt="apppic" />
                <div className="rewardContent">
                    <p className={`${subtitleClass} fs-18 fw-800`}>{cardSubTitle}</p>
                    <Link to={"/individuals/loyalty-program/drive"} onClick={() => {trackEvent(label+"Clicked")}}>
                        <NormalButton label={label} className={className} />
                    </Link>
                </div>
            </div>
        </div>
    );
};
